var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { noop } from '@ally/utilitarian';
import log from './whisper';
import { Modules, Federator } from './classes';
/**
 * Default options.
 * Provides sane defaults for everything needed to instantiate instances of
 * the Federator or Modules classes.
 */
var defaults = {
    log: log,
    apps: {},
    host: window.location.origin,
    hooks: {},
    externals: new Map(),
    onModuleLoaded: noop,
    isPrefetchingEnabled: true,
};
/**
 * Creates a new federator.
 * User can supply their own instance of Modules, or use the "blank" one
 * created for them.
 */
export default function create(options) {
    if (options === void 0) { options = {}; }
    var config = __assign(__assign({}, defaults), options);
    var modules = new Modules(config);
    return new Federator(__assign({ modules: modules }, config));
}
export * from './classes';
export * from './react';
export * from './types';
//# sourceMappingURL=index.js.map